import { createContext, useContext } from "react";

import axios from "axios";
import { authHeader } from '../helpers/authHeader';
import {SetCustomerList2} from '../store/customerAtom';
import LogicContext from "./LogicContext";


const CustomerContext = createContext({
  getSingleCustomer: (customer_id) => { },
  saveCustomerTableHeader: (xmlString) => { },
  getCustomers: () => { },
  getCustomers: () => { },
  
});

export function CustomerContextProvider(props) {
  const BASE_URL = process.env.REACT_APP_API_BASEURL_GET;

  // const [ customerTableHeader, setCustomerTableHead] = useRecoilState(customerTableHeaderAtom); 





  function getCustomerTableheaderHandler(){
                  axios.get(BASE_URL + '/customer-table-menu',authHeader() ).then((res) => {
        // setCustomerTableHead(res.data);
      }).catch((err)=> {})
  }



  function singleCustomerHandler(customer_id){
return axios.get(`/get-single-customer/${customer_id}`, authHeader());
  }





  function saveCustomerTableHeaderHandler(xmlString){
    var queryString = {"sql_ref_no":9,"c_code":1001,"user_id":"100001","user_token":"100200300","_xml2":`<root> ${xmlString} </root>`,"option" : "1"}
 
    axios.put('/update-customer-table-header', queryString, authHeader()).then(res => {
    });
        
  }



//  get customer list 
  async function  getCustomerHandler() {
    // var  userPref = {sql_ref_no : 6,  option : 4, c_code:1001}
        axios.get('/customer-list-no-cache', authHeader()).then(res => {
          if(res.data['customers']?.length > 0){
            SetCustomerList2(res.data['customers']);
          }
         
        });

    }


//  get customer list 
  async function  activeCustomersHandler() {

        axios.get('/active-customer', authHeader()).then(res => {
          SetCustomerList2(res.data['customers']);
        });
    }

  
  const context = {
    getSingleCustomer: singleCustomerHandler,
    saveCustomerTableHeader: saveCustomerTableHeaderHandler,
    getCustomers : getCustomerHandler,
    getActiveCustomers : activeCustomersHandler,
    getCustomerTableHeader : getCustomerTableheaderHandler,
  };

  return (
    <CustomerContext.Provider value={context}>
    {props.children}
    </CustomerContext.Provider>
  );
}

export default CustomerContext;
